import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import swal from 'sweetalert';
import axios from 'axios';
import CreateLicense from './CreateLicense';


class CreateCAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            cname: '',
            phone: '',
            logo: '',
            city: '',
            zip: '',
            address: '',
            details: '',
            stateAddress: '',
            c_a_name: '',
            errors: {
                cname: '',
                email: '',
                cpassword: '',
                password: '',
                c_a_name: '',
                location: ''

            },
            locationsList: [],
            location: 0,
            getLicenseObj: false

        }
    }

    checkRequirement = (name, value) => {

        let errors = this.state.errors;

        switch (name) {
            case 'cname':
                errors.cname =
                    value.length < 1
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'c_a_name':
                errors.c_a_name =
                    value.length < 1
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'location':
                errors.location =
                    value == "Choose..." || value == 0
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'email':
                errors.email =
                    validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                break;
            case 'password':
                errors.password =
                    value.length < 8
                        ? 'Password must be 8 characters long!'
                        : '';
                break;
            case 'cpassword':
                errors.password =
                    this.state.password !== value
                        ? 'Password and Confirm Password do not match!'
                        : '';
                break;
            default:
                break;
        }

        this.setState({ errors });
    }

    onChangeInput = (e) => {
        e.preventDefault();
        this.checkRequirement(e.target.name, e.target.value);
        this.setState({ [e.target.name]: e.target.value })
    }

    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                logo: reader.result
            });

        };
    }

    submit = (e) => {

        e.preventDefault();
        Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]))
        this.checkRequirement(e)
        if (validateForm(this.state.errors)) {


        } else {
            swal("Invalid Input ..!!")
            return
        }

        if (this.state.password != this.state.cpassword) {
            swal("Invalid Password ..!!")
            return
        }
        this.setState({ getLicenseObj: true });

    }
    componentDidMount() {
        this.getLocation()
    }
    getLocation = () => {
        var data = {}
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        let _this = this;
        axios.post(`${SERVER_IP}/location/list`, data, { withCredentials: true, headers: headers })
            .then(function (response) {

                if (response.status === 200) {
                    if (response.data.error === false) {
                        if (response.data.locationsList) {
                            _this.setState({ locationsList: response.data.locationsList })
                        }
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.getLocation();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    getLicenseData = (license_obj) => {
       this.setState({ getLicenseObj: false }, () => this.createCAdmin(license_obj));

    }
    createCAdmin = (license_obj) => {
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        var data = {
            ...license_obj,
            cooperate_name: this.state.cname,
            name: this.state.c_a_name,
            email: this.state.email,
            phone: this.state.phone,
            logo: this.state.logo,
            city: this.state.city,
            state: this.state.stateAddress,
            zip: this.state.zip,
            address: this.state.address,
            details: this.state.details,
            password: this.state.password,
            location_id: this.state.location == "Choose..." ? 0 : this.state.location,
            simualnis_id: ud.id,
            jwt: jwt,
        }
        const url = `${SERVER_IP}/create/cadmin`
        // For CAdmin in Corporate Admin Dashboard
        if (ud && ud.usertype === 1) {
            data.admin_type = "cadmin";
            data.c_id = ud.main_id
            url = `${SERVER_IP}/multi/admin/create`;
        }
        axios.post(url, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error === false) {
                        swal(response.data.message)
                        window.location.href = "/create/listcadmin"
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.createCAdmin(license_obj);
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    render() {
     
        const { errors } = this.state;
        return (
            <div>
                <div className="xp-breadcrumbbar">
                </div>
                <div className="xp-contentbar">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card m-b-30">
                                <div className="card-header">
                                    <h5 className="card-title text-black">Create Corporate Admin</h5>
                                    {/* <h6 className="card-subtitle">Here’s a quick example to demonstrate Bootstrap’s form styles. Keep reading for documentation on required classes, form layout, and more.</h6> */}
                                </div>
                                <div className="card-body">
                                    <div className="form-row">
                                        <div className="form-group  col-md-6">
                                            <label for="exampleInputEmail1">Corporate Name</label>
                                            <input type="text" onChange={this.onChangeInput} name="cname" className="form-control" placeholder="Enter Corporate Name" />
                                            {errors.cname.length > 0 && <span className='text-danger'>{errors.cname}</span>}
                                        </div>
                                        <div className="form-group  col-md-6">
                                            <label for="exampleInputEmail1">Corporate Admin Name</label>
                                            <input type="text" onChange={this.onChangeInput} name="c_a_name" className="form-control" placeholder="Enter Corporate Admin Name" />
                                            {errors.c_a_name.length > 0 && <span className='text-danger'>{errors.c_a_name}</span>}

                                        </div>
                                        {/* <div className="form-group  col-md-6">

                                            <label for="exampleInputEmail1">Upload Logo</label>
                                            <input type="file" onChange={this.handleImageChange} name="logo" className="form-control" placeholder="Upload Logo" accept="image/*" />
                                          
                                            <img src={this.state.logo}></img>
                                        </div> */}
                                        <div class="form-group">
                                            <div class="d-flex align-items-center">
                                                <div class="img_prev  mr-2">
                                                    <img id="blah" src={this.state.logo == "" ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUja_yxR-tYsw00WwLrFon7IVKTaVlDg1zYrpepzgxIg&s" : this.state.logo} class="img-thumbnail" alt="your image" />
                                                </div>
                                                <input type="file" onChange={this.handleImageChange} class="form-control-file border" name="file" placeholder="Upload Logo" accept="image/*" />
                                                {/* <input type="file" onChange={this.handleImageChange} name="logo" class="form-control-file border" name="file" placeholder="Upload Logo" accept="image/*" /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputEmail1">Email</label>
                                            <input type="text" onChange={this.onChangeInput} name="email" className="form-control" placeholder="Enter Email" />
                                            {errors.email.length > 0 && <span className='text-danger'>{errors.email}</span>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputEmail1">Phone</label>
                                            <input type="number" onChange={this.onChangeInput} name="phone" className="form-control" placeholder="Enter Phone" />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label for="exampleInputEmail1">Location</label>
                                        <select class="custom-select" name="location" id="inputGroupSelect01" onChange={this.onChangeInput} >
                                            <option selected>Choose...</option>
                                            {this.state.locationsList.map((list, index) =>
                                                <option value={list.id}>{list.location_name}</option>
                                            )}
                                        </select>
                                        {errors.location.length > 0 && <span className='text-danger'>{errors.location}</span>}

                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputEmail1">City</label>
                                            <input type="text" onChange={this.onChangeInput} name="city" className="form-control" placeholder="Enter City Name" />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label for="exampleInputEmail1">State</label>
                                            <input type="text" onChange={this.onChangeInput} name="stateAddress" className="form-control" placeholder="Enter State Name" />
                                        </div>
                                        <div className="form-group col-md-2">
                                            <label for="exampleInputEmail1">ZIP</label>
                                            <input type="number" onChange={this.onChangeInput} name="zip" className="form-control" placeholder="Enter ZIP" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label for="exampleInputEmail1">Address</label>
                                        <input type="text" onChange={this.onChangeInput} name="address" className="form-control" placeholder="Enter Address" />
                                    </div>
                                    <div className="form-group">
                                        <label for="exampleInputEmail1">Details</label>
                                        <input type="text" onChange={this.onChangeInput} name="details" className="form-control" placeholder="Enter Details" />
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputEmail1">Password</label>
                                            <input type="password" onChange={this.onChangeInput} name="password" className="form-control" placeholder="Enter Password" />
                                            {errors.password.length > 0 && <span className='text-danger'>{errors.password}</span>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputEmail1">Confirm Password</label>
                                            <input type="password" onChange={this.onChangeInput} name="cpassword" className="form-control" placeholder="Re Enter Password" />
                                            {errors.cpassword.length > 0 && <span className='text-danger'>{errors.cpassword}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CreateLicense getLicenseData={this.getLicenseData} getLicenseObj={this.state.getLicenseObj} />

                            <button type="submit" onClick={this.submit} className="btn btn-primary mt-3">Submit</button>



                        </div>
                    </div>
                </div>

            </div >
        )
    }
}
export default CreateCAdmin

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}